import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = {
    auth: authRoles.admin,

    routes: [
        {
            path: '/deferrals',

            component: FuseLoadable({
                loader: () => import('./DeferralsApp'),
            }),
        },
    ],
};

export default [Index];
